var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page"},[_c('first-screen'),_c('celebrity'),_c('highlights'),_c('fanstore'),_c('pricing'),_c('lab'),_c('trusted'),_c('featured'),_c('request'),_c('Footer'),_c('message')],1)}
var staticRenderFns = []

export { render, staticRenderFns }